// React and Libraries
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Ant Design
import { Button, Table, Tag } from 'antd';
import {
  CheckOutlined, EditFilled, SwapLeftOutlined, SwapRightOutlined,
} from '@ant-design/icons';

// UI Libraries
import H3Text from '@Uilib/h3Text';

// Constants & Helpers
import { QUANTITY, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';

// Common components
import BatchesTable from '@Components/Common/BatchesTable';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import PRZModal from '../../../../Common/UI/PRZModal';

// File specific components
import RecentTransactions from '@Components/Inventory/ManageProducts/ViewProduct/RecentTransactions';
import './style.scss';

// Actions
import invoiceActions from '../../../../../actions/invoiceActions';

function InvoiceLines(props) {

  const {
    cfInvoiceLine, visibleColumns, quickUpdateInvoiceApi, isEditable, activityLogUpdater, user, priceMasking, cfV2DocInvoice, poLines, selectedPurchaseOrder, selectedInvoice, onClick, callback, revertStockForInvoiceLoading, MONEY, quickUpdateInvoice, updateData, isHsnEditable,
  } = props;

  const [state, setState] = useState({
    showPRZModal: false,
    selectedDocumentId: null,
  });

  const { showPRZModal, selectedDocumentId } = state;

  const updateState = (newState) => {
    setState((oldState) => ({
      ...oldState,
      ...newState,
    }));
  };

  const { isDataMaskingPolicyEnable, isHideSellingPrice } = priceMasking;

  const bundleListColumns = [
    {
      title: 'SKU#',
      render: (record) => (
        <Fragment>
          <div onClick={() => updateState({ showPRZModal: true, selectedDocumentId: record?.product_sku_info?.product_sku_id })}>
            <a>
              {`#${record?.product_sku_info?.internal_sku_code}`}
            </a>
          </div>
        </Fragment>
      ),
    },
    {
      title: 'PRODUCT',
      render: (text, record) => (
        <div className="so-table__product-name">
          {record?.product_sku_name}
        </div>
      ),
    },
    {
      title: 'QUANTITY',
      render: (text, record) => (
        <div className="so-qty-input">
          {/* {`${Helpers.getValueTotalInObject(record?.product_batches, 'consumed_qty')} ${record?.uom_info?.[0]?.uqc?.toProperCase()}`} */}
          {`${record?.quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase()}`}
        </div>
      ),
    },
    {
      title: 'ISSUED QUANTITY',
      render: (text, record) => (
        <div className="so-qty-input">
          {`${record?.invoice_line_adjustment_issued_quantity} ${record?.uom_info?.[0]?.uqc?.toProperCase()}`}
        </div>
      ),
    },
  ];

  const getColumns = () => {

    const columns = [
      {
        title: '',
        render: (record) => (
          <div
            className="mobile-list__item"
          >
            <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">

              <div style={{ display: 'flex' }}>
                <H3Text text={`#${record?.product_sku_info?.product_sku_name}`} className="mobile-list__item-number" />
              </div>
              <div style={{ marginBottom: '5px' }}>
                {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'OUTWARD'
                  && (
                    <div className="ia-type-tag" style={{ backgroundColor: '#f15353' }}>
                      <SwapRightOutlined />
                      <H3Text text="Outgoing" className="" />
                    </div>
                  )}
                {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'INWARDS'
                  && (
                    <div className="ia-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
                      <SwapLeftOutlined />
                      <H3Text text="Incoming" className="" />
                    </div>
                  )}
              </div>
              <div className="mobile-list__item-info">
                <Tag color="processing">
                  {QUANTITY(record?.quantity, record?.uom_info?.[0]?.precision)}
                  {' '}
                  {record?.uom_info?.[0]?.uqc?.toProperCase() || ''}
                </Tag>
              </div>
              <div className="flex-align-space-between">
                <H3Text text={`${MONEY((record.unit_price), selectedInvoice?.org_currency_info?.currency_code)} Per Pcs`} className="mobile-list__item-info" />
                <H3Text text={MONEY((record.line_total_price || '0'), selectedInvoice?.org_currency_info?.currency_code)} className="mobile-list__item-info" />
              </div>
              <H3Text text={`Tax@ ${record.tax_info?.tax_value}%`} className="mobile-list__item-info" />
            </Link>
          </div>

        ),
        responsive: ['xs'],

      },
      {
        title: 'Product',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => {

          return (
            <Fragment>
              <div onClick={() => updateState({ showPRZModal: true, selectedDocumentId: item?.product_sku_info?.product_sku_id })}>
                <a>
                  {`#${item?.product_sku_info?.internal_sku_code}`}
                </a>
              </div>
              <div className="flex-align-c" style={{ gap: '10px' }}>
                <div>
                  {item?.product_sku_name}
                </div>
                <div style={{ marginLeft: 'auto', width: '20px' }}>
                  {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.CREATE, user) && (
                    <RecentTransactions
                      sellerId={selectedInvoice?.seller_info?.seller_id}
                      tenantId={selectedInvoice?.tenant_id}
                      productSkuId={item?.product_sku_info?.product_sku_id}
                      internalSkuCode={item?.product_sku_info?.internal_sku_code}
                      refProductCode={item?.product_sku_info?.ref_product_code}
                      productSkuName={item?.product_sku_name}
                      costumerID={selectedInvoice?.customer_id}
                      TransactionType="SALES_ORDER"
                    />
                  )}
                </div>
              </div>
              {item?.product_category_info?.category_path?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={item?.product_category_info?.category_path}
                  categoryName={item?.product_category_info?.category_path?.at(-1)}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
              {/* <H3Text text={item?.remarks} className="table-subscript" /> */}
              <div
                dangerouslySetInnerHTML={{ __html: item?.remarks }}
                className="table-subscript"
                style={{
                  width: '200px',
                  whiteSpace: 'pre-wrap',
                }}
              />
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div>
                  {(item?.product_sku_info?.product_type === 'BUNDLE')
                    && <H3Text text="Bundle" className="table-subscript table-subscript-tag" />}
                  {(item?.product_sku_info?.product_type === 'SERVICE')
                    && <H3Text text="Service" className="table-subscript table-subscript-tag" />}
                  {(!['SERVICE', 'BUNDLE'].includes(item?.product_sku_info?.product_type))
                    && <H3Text text="Goods" className="table-subscript table-subscript-tag" />}
                </div>

                <div style={{
                  fontSize: '10px', display: 'flex', marginLeft: '5px', marginTop: '7px',
                }}
                >
                  <H3Text text={item?.product_sku_info?.product_type === 'SERVICE' ? 'SAC' : 'HSN'} />
                  &nbsp;
                  <div className="invoice-table__hsn-value">
                    {!item?.hsn_code_isEditable && (
                      <div
                        className="view-invoice-table__hsn"

                      >
                        {item?.hsn_code && <H3Text text={item?.hsn_code} className="invoice-table__hsn" />}

                        {!selectedInvoice?.shopify_order_id && !selectedInvoice?.unicommerce_invoice_code && !selectedInvoice?.irn && !selectedInvoice?.e_way_bills && (
                          <EditFilled
                            className="edit-icon"
                            onClick={() => {
                              const copyData = JSON.parse(JSON.stringify(poLines));
                              copyData.map((record) => {
                                if (item.key === record.invoice_line_id) {
                                  record.hsn_code_isEditable = true;
                                }
                                return poLines;
                              });
                              updateData(copyData);
                            }}
                          />
                        )}
                      </div>
                    )}
                    {(item?.hsn_code_isEditable) && (
                      <div className="view-invoice-table__hsn">
                        <div className="view-invoice-table__hsn-value">
                          <input
                            value={item.hsn_code}
                            onChange={(e) => {
                              const copyData = JSON.parse(JSON.stringify(poLines));
                              copyData.map((record) => {
                                if (item.key === record.invoice_line_id) {
                                  record.hsn_code = e.target.value;
                                }
                                return poLines;
                              });
                              updateData(copyData);
                            }}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                const copyData = JSON.parse(JSON.stringify(poLines));
                                copyData.map((record) => {
                                  if (item.key === record.invoice_line_id) {
                                    record.hsn_code_isEditable = false;
                                  }
                                  return poLines;
                                });
                                updateData(copyData);
                                quickUpdateInvoice({
                                  hsn_code: item.hsn_code ? item.hsn_code : ' ',
                                  invoice_id: selectedInvoice.invoice_id,
                                  invoice_line_id: item.invoice_line_id,
                                }, '', isHsnEditable);
                              }
                            }}
                            className="invoice-table__hsn-input"
                            maxLength="10"
                          />
                        </div>
                        &nbsp;
                        <CheckOutlined
                          style={{ color: '#1890ff', cursor: 'pointer' }}
                          onClick={() => {
                            const copyData = JSON.parse(JSON.stringify(poLines));
                            copyData.map((record) => {
                              if (item.key === record.invoice_line_id) {
                                record.hsn_code_isEditable = false;
                              }
                              return poLines;
                            });
                            updateData(copyData);
                            quickUpdateInvoice({
                              hsn_code: item.hsn_code ? item.hsn_code : ' ',
                              invoice_id: selectedInvoice.invoice_id,
                              invoice_line_id: item.invoice_line_id,
                            }, '', isHsnEditable);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Fragment>
          );
        },
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'Quantity',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => (
          <div>
            {`${QUANTITY(item?.quantity, item?.uom_info?.[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            {Number(item?.free_quantity) > 0 ? (
              <div className="table-subscript">
                {`+ ${QUANTITY(item?.free_quantity, item?.uom_info?.[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || ''} Free`}
              </div>
            ) : ''}
          </div>
        ),
        visible: visibleColumns?.QUANTITY?.visible,
      },
      {
        title: 'Fulfilled',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => (
          <div>
            {`${QUANTITY(item?.invoice_line_adjustment_issued_quantity, item?.uom_info?.[0]?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
          </div>
        ),
        visible: visibleColumns?.FULFILLED?.visible,
      },
      {
        title: 'Rate',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view rate"} /> : MONEY((record.unit_price), selectedInvoice?.org_currency_info?.currency_code)),
        visible: visibleColumns?.PRICE?.visible,
      },
      {
        title: 'Tax',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => `${record.tax_group_info?.tax_value}%`,
        visible: visibleColumns?.TAX?.visible,
      },
      {
        title: 'Discount',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <Fragment>
            {Number(record?.line_discount_amount) > 0 ? (
              <Fragment>
                {record?.is_discount_in_percent ? `${Number(record?.line_discount_percentage).toPrecision(DEFAULT_CUR_ROUND_OFF) || '0'}%` : MONEY(record?.line_discount_amount, selectedInvoice?.org_currency_info?.currency_code)}
              </Fragment>
            ) : '-'}
          </Fragment>
        ),
        visible: visibleColumns?.DISCOUNT?.visible,
      },
      {
        title: 'Total',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view total amount"} /> : MONEY((record.line_total_price || '0'), selectedInvoice?.org_currency_info?.currency_code)),
        visible: visibleColumns?.TOTAL?.visible,
      },
    ];

    if (cfInvoiceLine?.length) {
      columns.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfInvoiceLine, visibleColumns, null, '', quickUpdateInvoiceApi, 'invoice_line_id', isEditable, activityLogUpdater, { invoice_id: selectedInvoice.invoice_id }, '', '', false, cfV2DocInvoice));
    }

    return columns?.filter((item) => item.visible);
  };

  return (
    <Fragment>
      <div className="invoice-table-wrapper">
        <Table
          bordered
          showHeader
          title={() => (
            <div className="invoice_lines-title__wrapper">
              <H3Text text={`Invoice Items (${poLines?.length})`} className="create-po__input-row__label" />
              {selectedInvoice?.bypass_inventory_change && !selectedInvoice?.unicommerce_invoice_code && selectedInvoice?.stock_status !== 'COMPLETED' && selectedInvoice?.status === 'CONFIRMED' && (
                <Button
                  type="primary"
                  ghost
                  onClick={() => onClick()}
                >
                  Issue Stock
                </Button>
              )}
            </div>
          )}
          size="small"
          columns={(selectedPurchaseOrder?.status === 'RECEIVED' || selectedPurchaseOrder?.status === 'PARTIALLY_RECEIVED') ? getColumns() : getColumns().filter((item) => item.title !== 'Received Quantity')}
          dataSource={(poLines || [])?.map((item, index) => ({
            ...item,
            key: item.invoice_line_id || index,
            // hsn_code_isEditable: true,
          }))}
          pagination={false}
          scroll={{ x: true }}
          loading={revertStockForInvoiceLoading}
          expandable={{
            rowExpandable: (record) => record?.batches_to_show?.length || record?.bundle_products?.length,
            // defaultExpandAllRows: true,
            expandedRowRender: (record) => (
              <React.Fragment>
                {record.bundle_products?.length ? (
                  <div className="view-bundle__inner-table">
                    <Table
                      bordered
                      showHeader
                      size="small"
                      scroll="scroll"
                      columns={bundleListColumns}
                      dataSource={record?.bundle_products?.map((item) => ({
                        ...item,
                        bundle_quantity: parseFloat(item?.quantity || '0'),
                        key: item.invoice_line_id,
                      }))}
                      pagination={false}
                      expandable={{
                        defaultExpandAllRows: false,
                        rowExpandable: (innerRecord) => innerRecord?.batches_to_show?.length || innerRecord?.bundle_products?.length,
                        expandedRowRender: (innerRecord) => (
                          <React.Fragment>
                            <BatchesTable
                              title="Issued Stock"
                              batches={innerRecord?.batches_to_show}
                              uomInfo={innerRecord?.uom_info?.[0]}
                              expiryDays={innerRecord?.product_sku_info?.expiry_days}
                              showCancel
                              revertStock={selectedInvoice?.bypass_inventory_change && !selectedInvoice?.shopify_order_id && !selectedInvoice?.unicommerce_invoice_code}
                              callback={callback}
                              showPendingQuantity
                              productInfo={record?.product_sku_info}
                            />
                          </React.Fragment>
                        ),
                      }}
                    />
                  </div>
                )
                  : (
                    <React.Fragment>
                      <BatchesTable
                        title="Issued Stock"
                        batches={record?.batches_to_show}
                        uomInfo={record?.uom_info?.[0]}
                        expiryDays={record?.product_sku_info?.expiry_days}
                        showCancel
                        revertStock={selectedInvoice?.bypass_inventory_change && !selectedInvoice?.unicommerce_invoice_code}
                        callback={callback}
                        productInfo={record?.product_sku_info}
                      />
                    </React.Fragment>
                  )}
              </React.Fragment>
            ),
          }}
        />
      </div>
      <PRZModal
        isOpen={showPRZModal}
        onClose={() => {
          updateState({ showPRZModal: false, selectedDocumentId: null });
        }}
        entityType="product"
        documentId={selectedDocumentId}
      />
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, InvoiceReducers, CFV2Reducers }) => ({
  MONEY: UserReducers.MONEY,
  user: UserReducers.user,
  revertStockForInvoiceLoading: InvoiceReducers.revertStockForInvoiceLoading,
  priceMasking: UserReducers.priceMasking,
  cfV2DocInvoice: CFV2Reducers.cfV2DocInvoice,
});

const mapDispatchToProps = (dispatch) => ({
  quickUpdateInvoice: (payload, callback, rollback) => dispatch(invoiceActions.quickUpdateInvoice(payload, callback, rollback)),
});

InvoiceLines.propTypes = {
  poLines: PropTypes.any,
  selectedInvoice: PropTypes.any,
  selectedPurchaseOrder: PropTypes.any,
  onClick: PropTypes.func,
  callback: PropTypes.func,
  revertStockForInvoiceLoading: PropTypes.bool,
  MONEY: PropTypes.func,
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceLines));
